export type AgentSavingsMode = "diy" | "endToEnd";

export interface AgentSavingsSectionCopy {
  heading: string;
  description: string;
}

export const AGENT_SAVINGS_SECTION: AgentSavingsSectionCopy = {
  heading: "Better Than an Agent (Without the Agent Price Tag)",
  description:
    "Get the same guidance and support you’d expect from a top agent minus the 2.5% commission. Our platform uses real-time data, AI pricing tools and Open for Inspection tool plus expert support to help you sell for thousands more.",
};

export interface AgentSavingsMetricCard {
  id: "agent-cost" | "unreserved" | "your-savings";
  amount: number;
  label: string;
}

export interface AgentSavingsMetricCardConfig {
  id: "agent-cost" | "unreserved" | "your-savings";
  label: string;
}

export const AGENT_SAVINGS_METRIC_CARDS_CONFIG: AgentSavingsMetricCardConfig[] = [
  {
    id: "agent-cost",
    label: "Agent Cost",
  },
  {
    id: "unreserved",
    label: "Unreserved",
  },
  {
    id: "your-savings",
    label: "Your Savings",
  },
];

export type AgentSavingsInputId = "estimated-sale-price" | "agent-commission" | "agent-marketing";

export interface AgentSavingsInputConfig {
  id: AgentSavingsInputId;
  label: string;
  min: number;
  max: number;
  valuePrefix?: string;
  valueSuffix?: string;
  step?: number;
}

export const AGENT_SAVINGS_INPUTS_CONFIG: AgentSavingsInputConfig[] = [
  {
    id: "estimated-sale-price",
    label: "Estimated Sale Price",
    min: 500000,
    max: 5000000,
    valuePrefix: "$ ",
  },
  {
    id: "agent-commission",
    label: "Agent Commission",
    min: 1,
    max: 4,
    valueSuffix: "%",
    step: 0.1,
  },
  {
    id: "agent-marketing",
    label: "Agent Marketing",
    min: 1000,
    max: 12000,
    valuePrefix: "$ ",
  },
];

export const DEFAULT_ESTIMATED_SALE_PRICE = 1500000;
export const DEFAULT_AGENT_COMMISSION = 2.5;
export const DEFAULT_AGENT_MARKETING = 5000;

export const DIY_COST = 900;
export const END_TO_END_COST = 6000;
